import { render, staticRenderFns } from "./invite-friends-before.vue?vue&type=template&id=9010ba72&scoped=true"
import script from "./invite-friends-before.vue?vue&type=script&lang=js"
export * from "./invite-friends-before.vue?vue&type=script&lang=js"
import style0 from "./invite-friends-before.vue?vue&type=style&index=0&id=9010ba72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9010ba72",
  null
  
)

export default component.exports